import { get } from '..';

const getAsset = async (assetId: string) => get(`assets/v2/${assetId}`);

export default getAsset;
